import axiosInstance from '../axios.config';
import { CallTranscript, normalizeTranscriptResponse } from 'utils/callTranscript';

/**
 * One call's transcript and summaries from cpass's store. Tenancy is the server's: it answers 403
 * for an organisation this user cannot act for and 404 for a call that is not that organisation's
 * — exactly as for a call with no transcript, or a server without the feature.
 *
 * Resolves to: the transcript; 'none' (404 — hide the panel); or throws for anything else.
 */
export type TranscriptResult = { kind: 'ok'; transcript: CallTranscript } | { kind: 'none' };

export const callTranscriptService = {
  async get(callId: string, organizationId?: string): Promise<TranscriptResult> {
    try {
      const res = await axiosInstance.get(`/v1/calls/${encodeURIComponent(callId)}/transcript`, {
        params: organizationId ? { organizationId } : {},
      });
      return { kind: 'ok', transcript: normalizeTranscriptResponse(res.data) };
    } catch (e: any) {
      if (e?.response?.status === 404) return { kind: 'none' };
      // Never the body: it is the server's message, but keep the console free of call data.
      throw new Error(e?.response?.status ? `HTTP ${e.response.status}` : 'network error');
    }
  },
};
